import React from 'react';
import { X } from 'react-feather';

import { motion } from 'framer-motion';

const DoctorModal = ({ closeModal }) => {
  const handleWhatsAppShare = () => {
    // Construct the message for WhatsApp
    const message = `Hello, I would like to speak to a doctor for a consultation.`;
    const whatsappUrl = `https://wa.me/254101757541?text=${encodeURIComponent(message)}`;

    // Open WhatsApp with the constructed message
    window.open(whatsappUrl, '_blank');
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 flex items-center justify-center bg-black/60 z-[9999] p-4 backdrop-blur-sm"
      onClick={closeModal}
    >
      <motion.div 
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.9, opacity: 0, y: 20 }}
        className="bg-white w-full max-w-md p-6 rounded-2xl relative text-center shadow-2xl overflow-y-auto max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={closeModal}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={24} />
        </button>

        <img
          src="https://images.unsplash.com/photo-1622253692010-333f2da6031d?q=80&w=1000&auto=format&fit=crop"
          alt="Consultation"
          className="w-full rounded-lg object-cover max-h-48 mx-auto"
        />

        <h2 className="text-2xl font-bold text-gray-800 mt-4 font-poppins">
          Speak to a Qualified Doctor
        </h2>
        <p className="text-gray-600 mt-2">
          Get professional medical advice from the comfort of your home. Connect with our experienced doctors via WhatsApp for a personalized consultation.
        </p>
        
        <button
          className="mt-6 w-full bg-primary-600 text-white py-3 rounded-xl font-bold hover:bg-primary-700 transition-all shadow-lg flex items-center justify-center"
          onClick={handleWhatsAppShare}
        >
          Start Consultation
        </button>
      </motion.div>
    </motion.div>
  );
};

export default DoctorModal;
